import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneReferenceRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneReference";
        this.parentEnterpriseComponent = "ProjectPlanPhaseMilestone";
        this.childEnterpriseComponent = "ProjectPlanPhaseMilestoneReference";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseMilestoneUSID";
    }
}

export default ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneReferenceRelationshipMetadata;